import React from "react"
import "./Footer.scss"
import { Link } from "react-router-dom"
import FooterLogo from "../../../assets/images/FooterLogo.svg"
import fbIcon from "../../../assets/images/facebook.svg"
import yelpIcon from "../../../assets/images/yelp.svg"
import twitterIcon from "../../../assets/images/twitter.svg"
import instagramIcon from "../../../assets/images/instagram.svg"
import linkedinIcon from "../../../assets/images/linkedin.svg"
import tpIcon from "../../../assets/images/trustpilot.svg"
import { CopyrightCircleOutlined } from "@ant-design/icons"
const Footer = () => {
    return (
        <div className="Footer">
            <div className="container">
                <div className="linksSection">
                    <div className="leftSection">
                        <Link to="/">
                            <img
                                src={FooterLogo}
                                alt="FooterLogo"
                                className="FooterLogo"
                            />
                        </Link>
                        <div className='addressInfo'>
                            <p>info@smartwithaheart.org</p>
                            <p>(202) 248-1679</p>
                        </div>
                        <div className='footerInfo'>
                            <p>Smart with a Heart is a registered 501(c)(3) charitable organization.</p>
                            <p>EIN 88-0712229</p>
                        </div>
                    </div>
                    <div className="rightSection">
                        <div className="linkColumn">
                            <p className="footerHeading">Connect</p>
                            <Link
                                to="/connect"
                                className="footerText"
                            >
                                Events
                            </Link>
                            <Link
                                to="/connect?section=volunteer"
                                className="footerText"
                            >
                                Volunteer
                            </Link>
                            <Link
                                to="/connect?section=partnership-opportunities"
                                className="footerText"
                            >
                                Partnership Opportunities
                            </Link>
                        </div>
                    </div>
                    <div className="rightSection">
                        <div className="linkColumn">
                            <p className="footerHeading">Prepare</p>
                            <Link
                                to="/gre"
                                className="footerText"
                            >
                                GRE Prep Program
                            </Link>
                            <Link
                                to={"/how-our-course-works"}
                                className="footerText"
                            >
                                How Our Course Works
                            </Link>
                            <Link
                                to="/faq"
                                className="footerText"
                            >
                                FAQs
                            </Link>
                        </div>
                        <div className="linkColumn">
                            <p className="footerHeading">Advice</p>

                            <Link to="/foresee-items" className="footerText">
                                What You Should Know Before Applying
                            </Link>
                            <Link to="/timeline" className="footerText">
                                Timeline
                            </Link>
                            <Link to="/gre-need" className="footerText">
                                Do I Need the GRE?
                            </Link>
                            <Link to="/gre-or-gmat" className="footerText">
                                Choosing Between the GRE and GMAT
                            </Link>

                        </div>
                        <div
                            className="linkColumn"
                            style={{ marginRight: "0px" }}
                        >
                            <p className="footerHeading">About Us</p>
                            <Link to="/our-mission" className="footerText">
                                Our Mission
                            </Link>
                            <Link to="/meet-our-leaders" className="footerText">
                                Our Board
                            </Link>
                            <a href="https://givebutter.com/Vo9aqn" className="footerText">
                                Donate
                            </a>
                            <Link to="/annual-report" className="footerText">
                                Annual Report
                            </Link>
                            <Link to="/contact-us" className="footerText">
                                Contact Us
                            </Link>
                            <Link to="/privacy-policy" className="footerText">
                                Privacy Policy
                            </Link>
                            <Link to="/terms-of-service" className="footerText">
                                Terms of Use
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="p-y-15">
                    <div className="socialIcons">
                        <a href="https://www.facebook.com/smartwithahearttestprep" target="_blank" className="footerText">
                            <img src={fbIcon} alt="fbIcon" className="icon" />
                        </a>
                        <a href="https://www.yelp.com/biz/sherpa-prep-washington-6" target="_blank" className="footerText">
                            <img src={yelpIcon} alt="yelpIcon" className="icon" />
                        </a>
                        <a href="https://twitter.com/smartwithaheart" target="_blank" className="footerText">
                            <img
                                src={twitterIcon}
                                alt="twitterIcon"
                                className="icon"
                            />
                        </a>
                        <a href="https://www.instagram.com/smart_with_a_heart_" target="_blank" className="footerText">
                            <img
                                src={instagramIcon}
                                alt="instaIcon"
                                className="icon"
                            />
                        </a>
                        <a href="https://www.linkedin.com/company/11748862" target="_blank" className="footerText">
                            <img src={linkedinIcon} alt="LIIcon" className="icon" />
                        </a>
                        <a href="https://www.trustpilot.com/review/sherpaprep.com" target="_blank" className="footerText">
                            <img
                                src={tpIcon}
                                alt="trustPilotIcon"
                                className="icon"
                            />
                        </a>
                    </div>
                    <p className="copyright">
                        <CopyrightCircleOutlined /> 2023 Smart with a Heart.
                    </p>
                    <p className="footerText2">
                        GRE® is a registered trademark of the Educational
                        Testing Service™, which is not affiliated with Smart
                        with a Heart™, Sherpa Prep® or this website.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Footer
